













































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import AmetrasSelectFieldTemplate from '@/fields/select/AmetrasSelectFieldTemplate.vue';
import AmetrasCheckBoxTemplate from '@/fields/checkbox/AmetrasCheckBoxTemplate.vue';
import AmetrasNumberFieldTemplate from '@/fields/text/AmetrasNumberFieldTemplate.vue';
import AmetrasTextAreaFieldTemplate from '@/fields/text-area/AmetrasTextAreaFieldTemplate.vue';
import AmetrasHexColorPickerTemplate from '@/fields/hex-color-picker/AmetrasHexColorPickerTemplate.vue';
import DynamicDocumentFontConfigurationTemplate from '@/views/dynamicdocuments/fields/dynamic-document-font-configuration-template.vue';

@Component({
  name: 'dynamic-document-signature-field-template',
  components: {
    DynamicDocumentFontConfigurationTemplate,
    AmetrasHexColorPickerTemplate,
    AmetrasTextAreaFieldTemplate,
    AmetrasNumberFieldTemplate,
    AmetrasCheckBoxTemplate,
    AmetrasTextFieldTemplate,
    AmetrasSelectFieldTemplate
  }
})
export default class DynamicDocumentSignatureFieldTemplate extends Vue {

  @Prop({required: true}) fieldConfig: DisguiseDto.DynamicDocumentFieldTypeSignatureDtoV2 | undefined;
  @Prop({required: false}) replacementToken: DisguiseDto.DynamicDocumentReplacementTokenDto[] | undefined;

  brickMenuOpened = false;

  $refs!: {
    input: AmetrasTextFieldTemplate
  };

  insertBrick(brick: DisguiseDto.DynamicDocumentReplacementTokenDto) {
    const textArea = this.$refs.input;
    if (textArea && brick.replacementToken && this.fieldConfig) {
      const htmlInputField = textArea.$el.querySelector('input');
      if (htmlInputField) {
        const oldText = this.fieldConfig.labelInputFieldValue || '';
        this.fieldConfig.labelInputFieldValue = oldText.substring(0, htmlInputField.selectionStart || 0)
            + brick.replacementToken
            + oldText.substring(htmlInputField.selectionEnd || 0, oldText.length);
      }
    }
  }

  toggleLabelAsInputField() {
    if (this.fieldConfig) {
      this.fieldConfig.labelInputFieldValue = undefined;
    }
  }

}
